export const PAGE_VIEW_UA = "pageViewed";
export const PAGE_VIEW = "page_view";
export const DEFAULT_CURRENCY = "EUR";
